import React, { useState } from 'react';
import { Button } from '@ui/buttons/button';
import './DiariosPontos.css';

interface DiarioPontosProps {
  id?: number;
  title: string;
  description: string;
  price: number;
  imageUrl: string;
  onPurchase: () => void;
  style?: React.CSSProperties;
  hideButton?: boolean;
  hidePurchaseButton?: boolean;
}

const DiarioPontos: React.FC<DiarioPontosProps> = ({
  title,
  description,
  price,
  imageUrl,
  onPurchase,
  hideButton = false,
  hidePurchaseButton = false,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const formatPrice = (price: number) => {
    const priceInReais = price / 10000;

    if (priceInReais >= 1000) {
      return priceInReais.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      return priceInReais.toLocaleString('pt-BR', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
    }
  };

  return (
    <div className="card">
      <div className="image_container" onClick={openModal}>
        <img src={imageUrl} alt={title} className="mb-2" />
      </div>
      <div className="title">
        <span>{title}</span>
      </div>
      <div className="size">
        <span>{description}</span>
      </div>
      <div className="price">
        <span>Cifras:</span>
        <span className="price2"> {formatPrice(price)}</span>
      </div>
      {!hideButton && !hidePurchaseButton && (
        <div className="action">
          <button className="cart-button" onClick={onPurchase}>
            <svg
              className="cart-icon"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                strokeLinejoin="round"
                strokeLinecap="round"
              ></path>
            </svg>
            <span>COMPRAR</span>
          </button>
        </div>
      )}

      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <img src={imageUrl} alt={title} className="modal-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default DiarioPontos;